import React, { CSSProperties, FC, useEffect, useState } from "react"
import { SelectItem } from "./AppMetierSelect"
import { ReferenceCode, useGetReferenceTyped } from "../../queries/ReferenceQueries"
import { CodeLibelle } from "../../client/backend-client/generated"
import { ConfigProvider, Select } from "antd"
import { CaretDownOutlined } from "@ant-design/icons"

export interface CodeLibelleItem {
  code: string
  libelle: string
}
export const codeLibelleToSelectItem = (
  code: string,
  refList: CodeLibelle[],
  includeCodeInLabel: boolean = false
): SelectItem<string> => ({
  value: code,
  label: includeCodeInLabel ? `${code} - ${refList.find(ref => ref.code === code)?.libelle}` : refList.find(ref => ref.code === code)?.libelle || ""
})

export const ReferenceSelect: FC<{
  referenceCode: ReferenceCode
  code?: string
  prescriberType?: CodeLibelle
  onChange?: (value: CodeLibelle | undefined) => void
  status?: "" | "warning" | "error"
  loading?: boolean
  disabled?: boolean
  allowClear?: boolean
  hideSelectionArrow?: boolean
  style?: CSSProperties
  refList?: CodeLibelle[] // A terme, je pense que c'est ce que vous voudrez garder pour passer la liste des références pré-chargée. Ca permet de se debarasser d'un format code/libelle présupposé sur toutes les listes de ref (utile pour motifAbandonAccesPlus par exemple)
}> = ({
  referenceCode,
  code,
  prescriberType,
  onChange,
  status,
  loading,
  disabled,
  allowClear,
  hideSelectionArrow,
  style,
  refList
}) => {
  const { isLoading: areReferencesLoading, data: references } = refList ? { data: refList, isLoading: false } : useGetReferenceTyped<CodeLibelle>(referenceCode)
  const includeCodeInLabel = referenceCode === ReferenceCode.CODE_APE

  const getReferenceOptions = (references: CodeLibelle[]) =>
    references.map(reference => codeLibelleToSelectItem(reference.code, references, includeCodeInLabel))

  const [referenceOptions, setReferenceOptions] = useState<SelectItem<string>[]>(
    references ? getReferenceOptions(references) : []
  )

  useEffect(() => {
    const filteredReferences = prescriberType
      ? references?.filter(reference => reference.typeRecommandeurCode === prescriberType.code)
      : references
    setReferenceOptions(filteredReferences ? getReferenceOptions(filteredReferences) : [])
    if (prescriberType && onChange && filteredReferences && filteredReferences.length === 1) {
      onChange(filteredReferences[0])
    }
  }, [references, prescriberType, code])

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorTextDisabled: "rgba(0, 0, 0, 0.50)"
          }
        }}
      >
        {references && (
          <Select<SelectItem<string>>
            value={code ? codeLibelleToSelectItem(code, references, includeCodeInLabel) : undefined}
            labelInValue
            suffixIcon={hideSelectionArrow ? null : <CaretDownOutlined />}
            style={style ?? { width: "100%" }}
            onChange={(item: SelectItem<string>) => {
              if (onChange) {
                const newCodeLibelle = item
                  ? references.find(reference => reference.code === item.value)
                  : undefined
                onChange(newCodeLibelle)
              }
            }}
            status={status}
            loading={areReferencesLoading || loading}
            disabled={disabled}
            allowClear={allowClear}
            options={referenceOptions}
          />
        )}
      </ConfigProvider>
    </>
  )
}
